import React from 'react';

const Loader = () => {
    return (
        <section className="loader-section">
            <div className="loader"></div>
        </section>
    );
};

export default Loader;